import { supportsPassive, getScrollOffset } from '../util/utility';

export default {
  data() {
    return {
      headerSticky: false,
      mobileMenuVisible: false
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.headerSticky = getScrollOffset() > 100;

      window.addEventListener(
        'scroll',
        () => {
          this.headerSticky = getScrollOffset() > 100;
        }, supportsPassive() ? { passive: true } : false
      );
    });
  },
  watch: {
    mobileMenuVisible(isVisible) {
      const func = isVisible ? 'add' : 'remove';

      document.body.classList[func]('mobile-menu-visible');
    }
  },
  methods: {
    showMenu() {
      this.mobileMenuVisible = true;
    },
    toggleMenu() {
      this.mobileMenuVisible = !this.mobileMenuVisible;
    },
    closeMenu() {
      this.mobileMenuVisible = false;
    }
  }
};
